import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import AxiosInstance from '../Api/axiosInstance';
import { apiEndpoints } from '../Api/apiEndpoints';
import { useDispatch } from 'react-redux';
import md5 from 'md5';
import { customLogs, handleApiCatchError } from '../components/util/util';

const Confdata = window['runConfig'];
const timeOut = 5000

const initialState = {
    language: "en",
    initailLag: 'en',
    countryDataArray: [],
    companyCountryDataArray: [],
    countriesArray: [],
    companyCountriesArray: [],
    adminstateDataArray: [],
    adminStatesArray: [],
    admincityDataArray: [],
    adminCitiesArray: [],
    companystateDataArray: [],
    companyStatesArray: [],
    companycityDataArray: [],
    companyCitiesArray: [],
    countryCode: "US",
    showCityTextboxAdmin: false,
    showCityTextboxCompany: false,
    openDialogBox: false,
    imageUrl: "",
    currentScreen: 1,
    imageUrlAdmin: "",
    imageUrlCompany: "",

    adminLocationInfo: {
        CountryId: "",
        StateId: "",
        CityId: "",
        ZipCode: "",
        Address1: "",
        Address2: ""
    },

    companyLocationInfo: {
        CountryId: "",
        StateId: "",
        CityId: "",
        ZipCode: "",
        Address1: "",
        Address2: ""
    },

    emailAddress: "",
    encryptedPassword: "",
    randomKey: "",
    checkBoxChecked: true,
    newEmailVerified: "",
    isOTPValid: false,
    otpResend: false,
    openEmailMessageBox: false,
    messageToDisplay: "",
    openLinkSetupBox: false,
    callCreateNewUserServlet: false,
    openLoader: false,

    snackBar: {
        open: false,
        message: "",
        severity: "success"
    },

    externalAuthUserData: {
        "firstname": "",
        "ssotype": "jodosso",
        "profileimage": "",
        "email": "",
        "sso": "",
        "lastname": "",
        "designation": ""
    },

    redirectToLoadingPage: false,
    companyAliasExist: true,
    companyNameVerified: false,
    createNewUserData: {},
    startTimer: false,
    time: {
        minutes: 0,
        seconds: 30
    },
    cityArray: [],
    cityData: [],
    comCityArray: [],
    comCityData: [],
    showTextFields: false,
    showCompanyAliasError: false,
    loadingSubscriptionPage: true,
    companyName: "",
    gstNumbr: "",
    useralias: "",
    cityError: false,
    companyCityError: false,
    resendButtonDisable: true,
    throwInvalidZipcodeError_Admin: false,
    throwInvalidZipcodeError_Company: false,
    stripeVerifySessionServletCounter: 2,
    openErrorPage: false,
    errorPageMessage: "Unable to process the request. Please try again later.",
    showOTPmsgLabel: false,
    CountryId: 0,
    stateData: [],
    stateArray: [],
    comStateData: [],
    comStateArray: [],
    serviceID: "",
    uploadImageFileName: "",
    bearerToken: "",
    language_email: "English",
    multilingual: null,
    checkCreateUserfailThenstopTheloader: false,
    theWidgetSession: false,
    handleBackButtonConditionForScriptExecution: 1,

}

export const globalReducer = createSlice({
    name: 'globalreducer',
    initialState,
    reducers: {
        setHandleBackButtonConditionForScriptExecution: (state, { payload }) => {
            state.handleBackButtonConditionForScriptExecution = payload;
        },
        setBearerToken: (state, { payload }) => {
            state.bearerToken = payload
        },
        setTheWidgetSession: (state, { payload }) => {
            state.theWidgetSession = payload;
        },
        setCheckCreateUserfailThenstopTheloader: (state, { payload }) => {
            state.checkCreateUserfailThenstopTheloader = payload;
        },
        setMultilingual: (state, { payload }) => {
            state.multilingual = payload;
        },

        setlanguage_email: (state, { payload }) => {
            state.language_email = payload;
        },
        SetuploadImageFileName: (state, { payload }) => {
            state.uploadImageFileName = payload;
        },
        setRandomKey: (state, { payload }) => {
            state.randomKey = payload;
        },
        setGstNumber: (state, { payload }) => {
            state.gstNumbr = payload;
        },
        setCompanyName: (state, { payload }) => {
            state.companyName = payload;
        },
        setCountryCode: (state, { payload }) => {
            state.countryCode = payload;
        },
        setInitailLag: (state, { payload }) => {
            state.initailLag = payload;
        },
        setstripeVerifySessionServletCounter: (state, { payload }) => {
            state.stripeVerifySessionServletCounter = payload;
        },
        setthrowInvalidZipcodeError_Admin: (state, { payload }) => {
            state.throwInvalidZipcodeError_Admin = payload;
        },
        setthrowInvalidZipcodeError_Company: (state, { payload }) => {
            state.throwInvalidZipcodeError_Company = payload;
        },
        setLanguage: (state, { payload }) => {
            state.language = payload;
        },
        setCountryDataArray: (state, { payload }) => {
            state.countryDataArray = payload;
        },
        setadminstateDataArray: (state, { payload }) => {
            state.adminstateDataArray = payload;
        },
        setCompanyCountryDataArray: (state, { payload }) => {
            state.companyCountryDataArray = payload;
        },
        setadmincityDataArray: (state, { payload }) => {
            state.admincityDataArray = payload;
        },
        setcompanystateDataArray: (state, { payload }) => {
            state.companystateDataArray = payload;
        },
        setcompanycityDataArray: (state, { payload }) => {
            state.companycityDataArray = payload;
        },
        setOpenDialogBox: (state, { payload }) => {
            state.openDialogBox = payload;
        },
        setImageUrl: (state, { payload }) => {
            state.imageUrl = payload;
        },
        setAdminLocationInfo: (state, { payload }) => {
            state.adminLocationInfo = payload;
        },
        setCompanyLocationInfo: (state, { payload }) => {
            state.companyLocationInfo = payload;
        },
        setshowCityTextboxAdmin: (state, { payload }) => {
            state.showCityTextboxAdmin = payload;
        },
        setshowCityTextboxCompany: (state, { payload }) => {
            state.showCityTextboxCompany = payload;
        },
        setemailAddress: (state, { payload }) => {
            state.emailAddress = payload;
        },
        setcurrentScreen: (state, { payload }) => {
            state.currentScreen = payload;
        },
        setimageUrlAdmin: (state, { payload }) => {
            state.imageUrlAdmin = payload;
        },
        setimageUrlCompany: (state, { payload }) => {
            state.imageUrlCompany = payload;
        },
        setcheckBoxChecked: (state, { payload }) => {
            state.checkBoxChecked = payload;
        },
        setopenEmailMessageBox: (state, { payload }) => {
            state.openEmailMessageBox = payload
        },
        setencryptedPassword: (state, { payload }) => {
            state.encryptedPassword = payload;
        },
        setopenLinkSetupBox: (state, { payload }) => {
            state.openLinkSetupBox = payload
        },
        setsnackBar(state, action) {
            state.snackBar = action.payload;
            customLogs(state.snackBar, "first")
        },
        setexternalAuthUserData(state, action) {
            state.externalAuthUserData = action.payload;
        },
        setopenLoader(state, { payload }) {
            state.openLoader = payload
        },
        setredirectToLoadingPage(state, { payload }) {
            state.redirectToLoadingPage = payload;
        },
        setcallCreateNewUserServlet(state, { payload }) {
            state.callCreateNewUserServlet = payload;
        },
        setcompanyNameVerified(state, { payload }) {
            state.companyNameVerified = payload;
        },
        setTime(state, { payload }) {
            state.time = payload;
        },
        setstartTimer(state, { payload }) {
            state.startTimer = payload;
        },
        setshowTextFields(state, { payload }) {
            state.showTextFields = payload;
        },
        setAdminStatesArray(state, { payload }) {
            state.adminStatesArray = payload;
        },
        setAdminCitiesArray(state, { payload }) {
            state.adminCitiesArray = payload;
        },
        setcompanyStatesArray(state, { payload }) {
            state.companyStatesArray = payload;
        },
        setcompanyCitiesArray(state, { payload }) {
            state.companyCitiesArray = payload;
        },
        setshowCompanyAliasError(state, { payload }) {
            state.showCompanyAliasError = payload
        },
        setnewEmailVerified(state, { payload }) {
            state.newEmailVerified = payload;
        },
        setcityError(state, { payload }) {
            state.cityError = payload;
        },
        setcompanyCityError(state, { payload }) {
            state.companyCityError = payload;
        },
        setresendButtonDisable(state, { payload }) {
            state.resendButtonDisable = payload;
        },
        setCountryId(state, { payload }) {
            state.CountryId = payload;
        },
        setStateArray(state, { payload }) {
            state.stateArray = payload;
        },
        setStateData(state, { payload }) {
            state.stateData = payload;
        },
        setComStateArray(state, { payload }) {
            state.comStateArray = payload;
        },
        setComStateData(state, { payload }) {
            state.comStateData = payload;
        },
        setCityData(state, { payload }) {
            state.cityData = payload;
        },
        setCityArray(state, { payload }) {
            state.cityArray = payload;
        },
        setComCityData(state, { payload }) {
            state.comCityData = payload;
        },
        setComCityArray(state, { payload }) {
            state.comCityArray = payload;
        }
    },
    extraReducers: (builder) => {

        builder.addCase(fetchLocationData.fulfilled, (state, { payload }) => {
            state.countryDataArray = payload;
            state.countriesArray = payload.map(item => item.countryname)
        })

        builder.addCase(fetchState.fulfilled, (state, { payload }) => {
            state.stateData = payload;
            state.stateArray = payload.map(item => item.statename)

        })
        builder.addCase(fetchCompanyLocationData.fulfilled, (state, { payload }) => {
            state.companyCountryDataArray = payload;
            state.companyCountriesArray = payload.map(item => item.countryname)

        })
        builder.addCase(fetchCompanyState.fulfilled, (state, { payload }) => {
            state.comStateData = payload;
            state.comStateArray = payload.map(item => item.statename)

        })
        builder.addCase(authenticateEmailId.pending, (state, { payload }) => {
            state.openLoader = true
        })

        builder.addCase(authenticateEmailId.fulfilled, (state, { payload }) => {
            state.openLoader = false;
            state.newEmailVerified = payload;

            if (payload === 1) {
                state.showOTPmsgLabel = true;
                state.startTimer = true;
                state.time = { ...state.time, minutes: 0, seconds: 30 }
            } else {
                state.openLoader = false;
            }
        })
        builder.addCase(authenticateEmailId.rejected, (state, { payload }) => {
            state.openLoader = false;
            state.snackBar = { ...state.snackBar, open: true, message: 'emailAuthFailed', severity: "error" }
        })
        builder.addCase(uploadImageAPI.pending, (state, { payload }) => {
            state.openEmailMessageBox = true
        })
        builder.addCase(uploadImageAPI.fulfilled, (state, { payload }) => {
            if (state.currentScreen === 1) {
                state.imageUrlAdmin = payload;
            } else {
                state.imageUrlCompany = payload;
            }
            state.openEmailMessageBox = false

        })
        builder.addCase(uploadImageAPI.rejected, (state, { payload }) => {
            if (state.currentScreen === 1) {
                state.imageUrlAdmin = "";
            } else {
                state.imageUrlCompany = "";
            }
            state.openEmailMessageBox = false

        })
        builder.addCase(createNewUser.fulfilled, (state, { payload }) => {
            if (payload.servicekey === "" && payload.apikey === "") {
                state.snackBar = { ...state.snackBar, open: true, message: 'apiKeyandServiceKeyNotFound', severity: "error" }
                state.openEmailMessageBox = false;
                state.callCreateNewUserServlet = false;
                state.openErrorPage = true;
                state.checkCreateUserfailThenstopTheloader = true
            }
            else if (payload.servicekey === "") {
                state.snackBar = { ...state.snackBar, open: true, message: 'serviceKeyNotFound', severity: "error" }
                state.openEmailMessageBox = false;
                state.callCreateNewUserServlet = false;
                state.openErrorPage = true;
                state.checkCreateUserfailThenstopTheloader = true
            }
            else if (payload.apikey === "") {
                state.snackBar = { ...state.snackBar, open: true, message: 'apiKeyNotFound', severity: "error" }
                state.openEmailMessageBox = false;
                state.callCreateNewUserServlet = false;
                state.openErrorPage = true;
                state.checkCreateUserfailThenstopTheloader = true
            }
            else if (payload.status === 1) {
                state.createNewUserData = payload;
            }
            else if (payload.status === 103) {
                state.snackBar = { ...state.snackBar, open: true, message: "Email id already exist", severity: "error" }
                state.openEmailMessageBox = false;
                state.callCreateNewUserServlet = false;
                state.openErrorPage = true;
            }
        })
        builder.addCase(createNewUser.rejected, (state, { payload }) => {
            state.callCreateNewUserServlet = false;
            state.openEmailMessageBox = false;
            state.openLoader = false;
            state.openErrorPage = true;
        })
        builder.addCase(checkForDuplicateCompanyName.pending, (state, { payload }) => {
            state.openEmailMessageBox = true;
        })
        builder.addCase(checkForDuplicateCompanyName.fulfilled, (state, { payload }) => {
            state.openEmailMessageBox = false;
            if (payload === "OrganisationList found Empty") {
                state.companyNameVerified = true;
                state.snackBar = { ...state.snackBar, open: true, message: 'uniqueCompanyNameVerified', severity: "success" }

            } else {
                state.companyNameVerified = false;
                state.openEmailMessageBox = false;
                state.snackBar = { ...state.snackBar, open: true, message: 'companyNameExistMsg', severity: "error" }
            }
        })
        builder.addCase(checkForDuplicateCompanyName.rejected, (state, { payload }) => {
            state.openEmailMessageBox = false
        })
        builder.addCase(checkForDuplicateCompanyAlias.fulfilled, (state, { payload }) => {
            if (payload === 1) {
                state.companyAliasExist = false;
                state.showCompanyAliasError = false;
                state.redirectToLoadingPage = true
                state.callCreateNewUserServlet = true;
            } else {
                state.companyAliasExist = true;
                state.showCompanyAliasError = true;
                state.openEmailMessageBox = false;
                state.callCreateNewUserServlet = false;
                state.redirectToLoadingPage = false

                if (payload === 120) {
                    state.errorPageMessage = "Unique Company ID already exists"

                } else if (payload === 118) {
                    state.errorPageMessage = "Unique Company ID not found"


                } else if (payload === 101) {
                    state.errorPageMessage = "Email-id not found"
                } else if (payload === 103) {
                    state.errorPageMessage = "Email-id already exist"

                } else if (payload === 110) {
                    state.errorPageMessage = "Service name not found"
                } else {
                    state.errorPageMessage = "Service name already exist"
                }
            }
        })
        builder.addCase(checkForDuplicateCompanyAlias.rejected, (state, { payload }) => {
            state.companyAliasExist = true;
            state.showCompanyAliasError = false;
            state.openEmailMessageBox = false
            state.openErrorPage = true;
        })
        builder.addCase(verifyOTP.fulfilled, (state, { payload }) => {
            if (payload === 1) {
                state.isOTPValid = payload;
            } else {
                state.openLoader = false;
                state.snackBar = {
                    open: true,
                    message: state.multilingual('invalidOTPMsg'),
                    severity: "error"
                }
            }
        })
        builder.addCase(verifyOTP.rejected, (state, { payload }) => {
            state.snackBar = {
                open: true,
                message: state.multilingual('internalServerErrorMsg'),
                severity: "error"
            }
        })
        builder.addCase(resendOTP.pending, (state, { payload }) => {
            state.otpResend = false;
        })

        builder.addCase(resendOTP.fulfilled, (state, { payload }) => {
            state.otpResend = payload;
            state.showOTPmsgLabel = true;
            state.time = { ...state.time, minutes: 0, seconds: 30 }
            state.resendButtonDisable = true;
        })
        builder.addCase(resendOTP.rejected, (state, { payload }) => {
            state.resendButtonDisable = false;
            state.snackBar = {
                open: true,
                message: state.multilingual('internalServerErrorMsg'),
                severity: "error"
            }
        })

        builder.addCase(StripeSessionVerifyServlet.fulfilled, (state, { payload }) => {
            function autoLoginToToolbar() {
                function base64EncodeUnicode(str) {
                    let utf8Bytes = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
                        return String.fromCharCode('0x' + p1);
                    })
                    return window.btoa(utf8Bytes)
                }
                let a = {
                    "app_name": "Jodo Toolbar",
                    "app_url": `${Confdata.apiUrl}/jodotoolbar/`,
                    "app_version": "1.2.7.4",
                    "app_date": new Date(),
                    "app_lang": state.language,
                    "app_id": "11",
                    "login_id": state.emailAddress,
                    "password": state.encryptedPassword,
                    "random_key": state.randomKey
                }

                let sociallogin = {
                    "firstname": "",
                    "lastname": "",
                    "app_lang": `${state.language === "en" ? "eng" : state.language === "hin" ? "hin" : state.language === "sp" ? "spanish" : "arab"}`,
                    "profileimage": state.imageUrlAdmin,
                    "email": state.externalAuthUserData.email,
                    "sso": "socialsso",
                    "ssotype": state.externalAuthUserData.ssotype,
                    "random_token": state.externalAuthUserData.random_token,
                    "responsedatetime": new Date(),
                    "status": 1,
                    "newEmailVerified": "Success",
                    "jodomoduleurl": `${Confdata.apiUrl}/jodotoolbar/`

                }

                const encryptedData = state.externalAuthUserData.ssotype === "jodosso" ?
                    base64EncodeUnicode(JSON.stringify(a))
                    :
                    base64EncodeUnicode(JSON.stringify(sociallogin))

                localStorage.removeItem("language")

                if (state.externalAuthUserData.ssotype === "jodosso") {
                    window.location.href = `${Confdata.apiUrl}/jodoworldsignon/AutoLoginServlet?a=${encryptedData}`
                } else {
                    window.location.href = `${Confdata.apiUrl}/jodoworldsignon/SocialSSOLoginServlet?authresponse=${encryptedData}`
                }
            }
            if (payload === 1) {
                autoLoginToToolbar()
            }
            else if (payload === "Timer Ended") {
                // autoLoginToToolbar()
                state.openErrorPage = true;
                customLogs("Timer has been ended. Can't make further api calls")
            }
        })

        builder.addCase(getUserAndOrganisationDetails.fulfilled, (state, { payload }) => {
            const [userdetails, orgdetails] = [payload[0].data.userdetails[0], payload[1].data.organisationdetails[0]]
            let useralias = userdetails.userparameterdetail.filter(item => item.parameter_id === 214);
            let userDesignation = userdetails.userparameterdetail.filter(item => item.parameter_id === 212);
            state.useralias = useralias.length === 0 ? "" : useralias[0].detail_description;
            state.externalAuthUserData = {
                ...state.externalAuthUserData,
                firstname: userdetails.username,
                profileimage: userdetails.userimage,
                ssotype: "existingUser",
                email: userdetails.login,
                lastname: userdetails.username,
                designation: userDesignation.length === 0 ? "" : userDesignation[0].detail_description
            }
            state.imageUrlAdmin = userdetails.userimage;
            state.adminLocationInfo = {
                ...state.adminLocationInfo,
                CountryId: userdetails.countryname ? userdetails.countryname : "",
                StateId: userdetails.statename ? userdetails.statename : "",
                CityId: userdetails.cityname ? userdetails.cityname : "",
                ZipCode: userdetails.pincode ? userdetails.pincode : "",
                Address1: userdetails.address1 ? userdetails.address1 : "",
                Address2: userdetails.address2 ? userdetails.address2 : ""
            }
            state.loadingSubscriptionPage = false;
            state.companyName = orgdetails.orgname;
            let companyLogo = orgdetails.organisationparameterdetails.filter(item => item.parameter_id === 138);
            let companyZipCode = orgdetails.organisationparameterdetails.filter(item => item.parameter_id === 102);
            state.imageUrlCompany = companyLogo.length === 0 ? "" : companyLogo[0].detail_description
            state.companyLocationInfo = {
                ...state.companyLocationInfo,
                CountryId: orgdetails.country ? orgdetails.country : "",
                StateId: orgdetails.state ? orgdetails.state : "",
                CityId: orgdetails.city ? orgdetails.city : "",
                ZipCode: (companyZipCode.length === 0 || !companyZipCode[0].detail_description) ? "" : companyZipCode[0].detail_description,
                Address1: orgdetails.address1 ? orgdetails.address1 : "",
                Address2: orgdetails.address2 ? orgdetails.address2 : ""
            }
            state.checkBoxChecked = false;
        })
    }
})

export const {
    setHandleBackButtonConditionForScriptExecution,
    setTheWidgetSession,
    setBearerToken,
    setCheckCreateUserfailThenstopTheloader,
    setMultilingual,
    setlanguage_email,
    SetuploadImageFileName,
    setRandomKey,
    setGstNumber,
    setCompanyName,
    setComCityData,
    setComCityArray,
    setCityArray,
    setCityData,
    setComStateArray,
    setComStateData,
    setStateData,
    setStateArray,
    setCountryId,
    setLanguage,
    setCountryDataArray,
    setCompanyCountryDataArray,
    setadminstateDataArray,
    setadmincityDataArray,
    setcompanystateDataArray,
    setcompanycityDataArray,
    setshowCityTextboxAdmin,
    setshowCityTextboxCompany,
    setOpenDialogBox,
    setImageUrl,
    setAdminLocationInfo,
    setCompanyLocationInfo,
    setemailAddress,
    setencryptedPassword,
    setcurrentScreen,
    setimageUrlAdmin,
    setimageUrlCompany,
    setcheckBoxChecked,
    setopenEmailMessageBox,
    setDATA_OBJ,
    setsnackBar,
    setexternalAuthUserData,
    setopenLoader,
    setredirectToLoadingPage,
    setcallCreateNewUserServlet,
    setcompanyNameVerified,
    setTime,
    setstartTimer,
    setshowTextFields,
    setAdminStatesArray,
    setAdminCitiesArray,
    setcompanyStatesArray,
    setcompanyCitiesArray,
    setshowCompanyAliasError,
    setnewEmailVerified,
    setcityError,
    setcompanyCityError,
    setresendButtonDisable,
    setthrowInvalidZipcodeError_Admin,
    setthrowInvalidZipcodeError_Company,
    setstripeVerifySessionServletCounter,
    setCountryCode,
    setInitailLag
} = globalReducer.actions;

export default globalReducer.reducer;

export const fetchLocationData = createAsyncThunk('globalreducer/fetchLocationData', async (t, { dispatch }) => {
    const response = await AxiosInstance.get(apiEndpoints().CRUD_API_MASTER + 'country_state_city/country', {

        headers: {
            'token': Confdata.token,
            'token_secret': Confdata.tokensecret
        }, timeout: timeOut
    }).catch((error) => {
        const errorMessage = handleApiCatchError(error)
        dispatch(setsnackBar(
            {
                open: true,
                message: errorMessage ? t(errorMessage) : errorMessage,
                severity: "error"
            }))
    })

    return response.data.country_master
})

// master api for fetch country list
export const fetchCompanyLocationData = createAsyncThunk('globalreducer/fetchCompanyLocationData', async (t, { dispatch }) => {
    const response = await AxiosInstance.get(apiEndpoints().CRUD_API_MASTER + 'country_state_city/country', {
        headers: {
            'content-type': 'application/json',
            'token': Confdata.token,
            'token_secret': Confdata.tokensecret
        }, timeout: timeOut
    }).catch((error) => {
        const errorMessage = handleApiCatchError(error)
        dispatch(setsnackBar(
            {
                open: true,
                message: errorMessage ? t(errorMessage) : errorMessage,
                severity: "error"
            }))
    })

    return response.data.country_master
})

// master api for fetch state list

export const fetchState = createAsyncThunk('globalreducer/fetchState', async (data, { dispatch }) => {
    const id = data.CountryId
    const t = data.multilingualMessage
    const response = await AxiosInstance.get(apiEndpoints().CRUD_API_MASTER + 'country_state_city/state/' + id, {
        headers: {
            'content-type': 'application/json',
            'token': Confdata.token,
            'token_secret': Confdata.tokensecret
        }, timeout: timeOut
    }).catch((error) => {
        const errorMessage = handleApiCatchError(error)
        dispatch(setsnackBar(
            {
                open: true,
                message: errorMessage ? t(errorMessage) : errorMessage,
                severity: "error"
            }))
    })


    // 
    return response.data.state_master
})

export const fetchCompanyState = createAsyncThunk('globalreducer/fetchCompanyState', async (data) => {
    const id = data.CountryId
    const t = data.multilingualMessage
    const response = await AxiosInstance.get(apiEndpoints().CRUD_API_MASTER + 'country_state_city/state/' + id, {
        headers: {
            'content-type': 'application/json',
            'token': Confdata.token,
            'token_secret': Confdata.tokensecret
        }, timeout: timeOut
    }).catch((error) => {
        const errorMessage = handleApiCatchError(error)
        dispatch(setsnackBar(
            {
                open: true,
                message: errorMessage ? t(errorMessage) : errorMessage,
                severity: "error"
            }))
    })


    return response.data.state_master
})
// master api for fetch city list

export const fetchCities = (id, id2, t) => async (dispatch) => {
    const city = []
    const response = await AxiosInstance.get(apiEndpoints().CRUD_API_MASTER + 'country_state_city/city/' + id + "/" + id2, {
        headers: {
            'content-type': 'application/json',
            'token': Confdata.token,
            'token_secret': Confdata.tokensecret
        }, timeout: timeOut
    }).catch((error) => {
        const errorMessage = handleApiCatchError(error)
        dispatch(setsnackBar(
            {
                open: true,
                message: errorMessage ? t(errorMessage) : errorMessage,
                severity: "error"
            }))
    })


    if (response.data.city_master !== null) {
        const name = response.data?.city_master.map(item => item.cityname)
        dispatch(setCityArray(response?.data ? name : null))
    } else {
        dispatch(setCityArray(city))
    }
}

export const comfetchCities = (id, id2, t) => async (dispatch) => {
    const response = await AxiosInstance.get(apiEndpoints().CRUD_API_MASTER + 'country_state_city/city/' + id + "/" + id2, {
        headers: {
            'content-type': 'application/json',
            'token': Confdata.token,
            'token_secret': Confdata.tokensecret
        }, timeout: timeOut
    }).catch((error) => {
        const errorMessage = handleApiCatchError(error)
        dispatch(setsnackBar(
            {
                open: true,
                message: errorMessage ? t(errorMessage) : errorMessage,
                severity: "error"
            }))
    })

    if (response.data.city_master !== null) {
        const name = response.data.city_master.map(item => item.cityname)
        dispatch(setComCityArray(response.data ? name : null))
    }
    else {
        dispatch(setComCityArray(city))
    }
}


// *** This API provides us with randomKey1 and randomKey2. randomKey1 is added to the password 
//for security reasons, and randomKey2 is needed for social login. ***

export const returnKey = (pass, t) => async (dispatch) => {
    try {
        const response = await AxiosInstance.get(
            apiEndpoints().GET_PASSWOED_KEY + 'LoginWebserviceHandle?methodname=GenerateKey&data={"appid":1}'
        );

        if (response.status === 200) {
            const passKey = `${pass}${response.data.keyvalue1}`;
            dispatch(setencryptedPassword(md5(passKey)));
            dispatch(setRandomKey(response.data.keyvalue2));
        }
    } catch (error) {
        const errorMessage = handleApiCatchError(error)
        dispatch(setsnackBar(
            {
                open: true,
                message: errorMessage ? t(errorMessage) : errorMessage,
                severity: "error"
            }))
    }
};

// This API takes email and language from the user. If the user is new,
// it returns status === 1, indicating a new customer. Otherwise, it returns 103.its indicating user already exist.

export const authenticateEmailId = createAsyncThunk('globalreducer/authenticateEmailID', async (data, { dispatch }) => {
    const t = data.multilingual
    try {
        const response = await AxiosInstance.get(
            `StripeApiWebhook/StripeEmailServlet?email=${data.email}&language=${data.language}`
        );

        return response.data.status;
    } catch (error) {
        const errorMessage = handleApiCatchError(error)
        dispatch(setsnackBar(
            {
                open: true,
                message: errorMessage ? t(errorMessage) : errorMessage,
                severity: "error"
            }))
    }
})

export const userApiTokenGenerate = createAsyncThunk(
    'globalreducer/tokenGenerate',
    async (data, { dispatch }) => {
        const t = data.multilingualMessage;

        try {
            const response = await AxiosInstance.post(
                apiEndpoints().CRUD_API_USERS + 'v1/token_generate',
                data, // Directly pass the data object
                {
                    headers: {
                        'content-type': 'application/json',
                        'token': Confdata.token,
                        'token_secret': Confdata.tokensecret
                    },
                    timeout: timeOut
                }
            );

            // Check if the response is successful
            if (response?.data?.status === 1) {
                dispatch(setBearerToken(response?.data?.jwt_token)); // Fix: Correct token key
                return response.data.status;
            } else {
                throw new Error(response?.data?.statusdesc || 'Token generation failed');
            }

        } catch (error) {
            const errorMessage = handleApiCatchError(error);
            dispatch(setsnackBar({
                open: true,
                message: errorMessage ? t(errorMessage) : 'An error occurred',
                severity: "error",
            }));
            throw error;  // Re-throw to let the thunk handle the rejection
        }
    }
);



// verify otp
export const verifyOTP = createAsyncThunk('globalreducer/verifyOTP', async (data, { dispatch }) => {
    const t = data.multilingualMessage
    const response = await AxiosInstance.post(apiEndpoints().CRUD_API_USERS + 'v1/otp_verify', {
        "otp": data.otp,
        "emailid": data.email
    },
        {
            headers: {
                'content-type': 'application/json',
                'token': Confdata.token,
                'token_secret': Confdata.tokensecret
            }, timeout: timeOut
        })
        .catch((error) => {
            const errorMessage = handleApiCatchError(error)
            dispatch(setsnackBar(
                {
                    open: true,
                    message: errorMessage ? t(errorMessage) : errorMessage,
                    severity: "error"
                }))
        })
    // dispatch(setBearerToken(response?.data?.token));
    return response.data.status
})

// Generate resend OTP 
export const resendOTP = createAsyncThunk('globalreducer/resendOTP', async (data) => {
    const t = data.multilingual
    const response = await AxiosInstance.post(apiEndpoints().CRUD_API_USERS + 'generate_otp', {
        "emailid": data.emailid,
        "type": 4,
        "apikey": "35fgdg",
        "language": data.language,

    },
        {
            headers: {
                'content-type': 'application/json',
                'token': Confdata.token,
                'token_secret': Confdata.tokensecret
            }, timeout: timeOut
        }).catch((error) => {
            const errorMessage = handleApiCatchError(error)
            dispatch(setsnackBar(
                {
                    open: true,
                    message: errorMessage ? t(errorMessage) : errorMessage,
                    severity: "error"
                }))
        })
    return response.data.status
})

// upload api to get url of image 
export const uploadImageAPI = createAsyncThunk('globalreducer/uploadImageAPI', async (imageInfo) => {
    const response = await AxiosInstance.post(apiEndpoints().UPLOAD_IMG_API, {
        filename: imageInfo.filename,
        filedata: imageInfo.filedata
    },
        {
            headers: {
                'content-type': 'application/json',
                'token': Confdata.token,
                'token_secret': Confdata.tokensecret
            }, timeout: timeOut
        })
    return response.data.filepath;
})

//create new user
export const createNewUser = createAsyncThunk('globalreducer/createNewUser', async (DATA_OBJ, { dispatch, getState }) => {
    const t = DATA_OBJ.multilingual;
    const bearerToken = getState().globalreducer.bearerToken;
    console.log(bearerToken, "tokenn")
    // const header={
    //     'Authorization':`Bearer ${bearerToken}`
    // }
    const JSON_DATA_OBJ = JSON.stringify(DATA_OBJ)
    const response = await AxiosInstance.post(`StripeApiWebhook/StripeCreateServlet`, JSON_DATA_OBJ)
        .catch((error) => {
            const errorMessage = handleApiCatchError(error)
            dispatch(setsnackBar(
                {
                    open: true,
                    message: errorMessage ? t(errorMessage) : errorMessage,
                    severity: "error"
                }))
        })
    localStorage.removeItem("isGoogle");
    localStorage.removeItem("isLinkedin");
    
    return response.data
})
// stripe verify servlate 

export const StripeSessionVerifyServlet = createAsyncThunk('globalreducer/StripeSessionVerifyServlet', async (session_data, { dispatch, getState }) => {
    const JSON_SESSION_DATA = JSON.stringify(session_data);
    const response = await AxiosInstance.post('StripeApiWebhook/StripeSessionVerifyServlet', JSON_SESSION_DATA)
    customLogs(response.data, "avhan")
    if (response.data.status === 0) {
        let counter = getState().globalreducer.stripeVerifySessionServletCounter;
        if (counter === 0) {
            return 1
        }
        if (counter === 1) {
            dispatch(setTheWidgetSession(true))
        }

        dispatch(setstripeVerifySessionServletCounter(counter - 1))
        setTimeout(() => {
            dispatch(StripeSessionVerifyServlet(session_data));
        }, 5000);
    }

    if (response.data.status === 1) {
        dispatch(setTheWidgetSession(true))
        return 1
    }
})

export const checkForDuplicateCompanyName = createAsyncThunk('globalreducer/checkForDuplicateCompanyName', async (company_name, { dispatch }) => {
    const response = await AxiosInstance.post(apiEndpoints().CRUD_API_ORG + 'search_org', {
        "organisationid": "",
        "orgname": company_name
    },
        {
            headers: {
                'content-type': 'application/json',
                'token': Confdata.token,
                'token_secret': Confdata.tokensecret
            }, timeout: timeOut
        })
    return response.data.statusdesc
})


export const checkForDuplicateCompanyAlias = createAsyncThunk('globalreducer/checkForDuplicateCompanyAlias', async (bodyContent) => {
    const JSON_BODY_CONTENT = JSON.stringify(bodyContent)
    const response = await AxiosInstance.post('/StripeApiWebhook/URLVerify', JSON_BODY_CONTENT, {
        headers: {
            'content-type': 'application/json',
            'token': Confdata.token,
            'token_secret': Confdata.tokensecret
        }, timeout: timeOut
    })
    return response.data.status
})

export const getUserAndOrganisationDetails = createAsyncThunk('globalreducer/getUserAndOrganisationDetails', async (obj, { dispatch }) => {
    const { login_id, token, t } = obj;
    const user_response = await AxiosInstance.get(apiEndpoints().GET_USER_BY_LOGINID + login_id, {
        headers: {
            'content-type': 'application/json',
            'token': Confdata.token,
            'token_secret': Confdata.tokensecret
        }, timeout: timeOut
    })
    const org_response = await AxiosInstance.get(apiEndpoints().CRUD_API_ORG + 1, {
        headers: {
            'ACS_SESSION_ID': token
        }, timeout: timeOut
    }).catch((error) => {
        const errorMessage = handleApiCatchError(error)
        dispatch(setsnackBar(
            {
                open: true,
                message: errorMessage ? t(errorMessage) : errorMessage,
                severity: "error"
            }))
    })
    const responses = await axios.all([user_response, org_response])

    return responses
})



// writelogApi
export const writeLog = (logType, msg) => async (dispatch) => {
    try {
        if (!msg) return;
        let logWriteType;
        switch (logType) {
            case 1:
                logWriteType = "DEBUG";
                break;
            case 2:
                logWriteType = "ERROR";
                break;
            case 3:
                logWriteType = "INFO";
                break;
            default:
                return;
        }
        const dataRequest = {
            app_functionid: 31071,
            actiondatetime: moment().format("YYYY-MM-DD HH:mm:ss"),
            loglevel: logWriteType,
            message: msg
        };
        dispatch(writeLogDelay(dataRequest));
    } catch (error) {
        console.error("writeLog::::", error);
    }
};

export const writeLogDelay = (dataRequest) => async (dispatch, getState) => {
    try {
        const serverLinkForLog = `${Confdata.apiUrl}/logwriteApi/log/write`;
        await axios.post(serverLinkForLog, dataRequest, {
            headers: {
                token: Confdata.token,
                token_secret: Confdata.tokensecret
            },
            timeout: timeOut
        });
    } catch (error) {
        console.error("writeLogDelay::::", error);
    }
};
